import axios from "axios";
import { Dispatch } from "redux";
import { baseUrl } from "../api";
import { setAccountName, setBankList, setWalletResponse, setWalletTransactionResponse, setWithdrawalAccount } from ".";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AccountResolutionResponse, BankResponse, createWithdrawalWalletDTO, updatePin, updateWithdrawalWalletDTO } from "./interface";



export const getLandlordWalletRequest =()=>async(dispatch:Dispatch)=>{
    try {
        const response = await axios.get(baseUrl.wallet)

        dispatch(setWalletResponse(response.data))
       
    } catch (error) {
        console.log(error);
        
    }
}


export const getLandlordTransactionsRequest =()=>async(dispatch:Dispatch)=>{
    try{
        const response = await axios.get(baseUrl.transactions)
        dispatch(setWalletTransactionResponse(response.data))
    }catch(error){
        console.log(error);
        
    }
}


export const getBankLists = createAsyncThunk<BankResponse, void>(
    "wallet/getBankLists",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get<BankResponse>(`${baseUrl.wallet}/banks`);
        if (!response.data.status) {
          return rejectWithValue(response.data.message);
        }
        return response.data;
      } catch (error:any) {
        return rejectWithValue(error.response?.data?.message || "Failed to fetch bank list");
      }
    }
  );
  
  export const getAccountInformation = createAsyncThunk<string,{ accountNumber: string; code: string }>(
    "wallet/getAccountInformation",
    async ({ accountNumber, code }, { rejectWithValue }) => {
      try {
        const response = await axios.get<AccountResolutionResponse>(
          `${baseUrl.wallet}/resolve-account`,
          {
            params: {
              account_number: accountNumber,
              bank_code: code,
            },
          }
        );
        if (!response.data.status) {
          return rejectWithValue(response.data.message);
        }
        return response.data.data.account_name;
      } catch (error:any) {
        return rejectWithValue(error.response?.data?.message || "Failed to fetch account information");
      }
    }
  );



  export const createWithdrawalWallet = (data:createWithdrawalWalletDTO)=>async(dispatch:Dispatch)=>{
    try {
        await axios.post(`${baseUrl.wallet}/withdrawal-account`, data)
        return true
    } catch (error) {
        console.log(error);
        
    }
  }
  export const upDateWithdrawalWallet = ( data:updateWithdrawalWalletDTO)=>async(dispatch:Dispatch)=>{
    try {
        await axios.put(`${baseUrl.wallet}/withdrawal-account`, data)
        return true
    } catch (error) {
        console.log(error);
        
    }
  }


  export const getWithdrawalWallet = ()=>async(dispatch:Dispatch)=>{
    try {
      const response =  await axios.get(`${baseUrl.wallet}/withdrawal-account`)
        return dispatch(setWithdrawalAccount(response.data))
    } catch (error) {
        console.log(error);
        
    }
  }
  

  export const setWithdrawalPin= ({id, data}:{id:string, data:{pin:string}}) => async(dispatch:Dispatch)=>{
    try {
        await axios.post(`${baseUrl.wallet}/${id}/pin`,data)
        return true
    } catch (error) {
        console.log(error);
        
    }
  }


  export const updateWithdrawalPin= ({id, data}:{id:string, data:updatePin}) => async(dispatch:Dispatch)=>{
    try {
        await axios.patch(`${baseUrl.wallet}/${id}/pin`,data )
        return true
    } catch (error) {
        console.log(error);
        
    }
  }
  export const confirmWithdrawalPin= ({id, data}:{id:string, data:string}) => async(dispatch:Dispatch)=>{
    try {

      const response=  await axios.post(`${baseUrl.wallet}/${id}/confirm-pin`, {pin:data} )
      const status:boolean = response.data.status
        return status
    } catch (error) {
        console.log(error);
        
    }
  }

  export const InitiateWithdrawTransfer = (amount:number)=> async (dispatch:Dispatch)=>{
    try {
      await  axios.post(`${baseUrl.payment}/withdraw`, {amount:amount})
     return true
    } catch (error) {
      return false
    }
  }